<template>
    <div class="container-waiting-room">
        <div class="waiting-room">
            <span class="waiting-title">
                {{$t("views.WaitingRoom.title")}}
            </span>
            <div class="candidates-container">
                <div class="candidates candidates0">
                    <icon-candidate :index="0" :width="calcWidth(0)" :color="candidates[0] ? candidates[0].color : 'roxo'"></icon-candidate>
                    <img src="../assets/losang-waiting.png" alt="" class="losango losango0">
                </div>
                <div class="candidates candidates1">
                    <icon-candidate v-if="candidates[1]" :name="candidates[1].name" :index="1" :width="calcWidth(1)" :color="candidates[1].color"></icon-candidate>
                    <div class="lds-ring" v-if="!candidates[1]">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <img src="../assets/losang-waiting.png" alt="" class="losango losango1">
                </div>
                <div class="candidates candidates2">
                    <icon-candidate v-if="candidates[2]" :name="candidates[2].name" :index="2" :width="calcWidth(2)" :color="candidates[2].color"></icon-candidate>
                    <div class="lds-ring" v-if="!candidates[2]">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <img src="../assets/losang-waiting.png" alt="" class="losango losango2">
                </div>
                <div class="candidates candidates3">
                    <icon-candidate v-if="candidates[3]" :name="candidates[3].name" :index="3" :width="calcWidth(3)" :color="candidates[3].color"></icon-candidate>
                    <div class="lds-ring" v-if="!candidates[3]">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <img src="../assets/losang-waiting.png" alt="" class="losango">
                </div>
            </div>
            <!-- <div class="rules-waiting">
                <p class="waiting-rule">Estamos aguardando todos os participantes entrarem para liberar o jogo.</p>
                <p class="waiting-rule">Você pode acompanhar o tempo restante para o início do jogo na parte superior da tela e enquanto isso 
                você poderá ver as regras<span v-if="formedGroup"> e já ir conversando com seu grupo no chat.</span>
                </p>
            </div> -->
            <!-- <div class="acceptance_button"
                 :class="!formedGroup ? 'notFormed' : 'formed'" 
                 @click="next">
                <span>Regras</span> -->
                <!-- <div class="arrow-right"></div> -->
            <!-- </div> -->
            <div class="acceptance_button" @click="chat">
                <img src="../assets/chat-button-icon.png" alt="chat button icon">
                <span>Chat</span>
                <!-- <div class="arrow-right"></div> -->
            </div>
        </div>
    </div>
</template>
<script>
import IconCandidate from '../components/Shared/IconCandidate.vue'
import HeaderDefault from '../components/Sections/HeaderDefault.vue'
export default {
    components:{
        IconCandidate,
        HeaderDefault
    },
    props:{
        candidates : {

        },
        formedGroup : {

        }
    },
    async created(){
        
    },
    methods: {
        next(){
            this.$router.push('/rules')
        },
        chat(){
            this.$router.push('/chat-initial')
        },
        calcWidth(index){
            switch(index){
                case 0 : 
                    return 90
                    break;
                case 1 : 
                    return 70
                    break;
                case 2 : 
                    return 70
                    break;
                case 3 : 
                    return 60
                    break;
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    .lds-ring {
        display: inline-block;
        position: relative;
        width: 40px;
        height: 40px;
    }
    .lds-ring div {
        box-sizing: border-box;
        display: block;
        position: absolute;
        width: 35px;
        height: 35px;
        margin: 3px;
        border: 4px solid #cfcfcf;
        border-radius: 50%;
        animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
        border-color: #cfcfcf transparent transparent transparent;
    }
    .lds-ring div:nth-child(1) {
        animation-delay: -0.45s;
    }
    .lds-ring div:nth-child(2) {
        animation-delay: -0.3s;
    }
    .lds-ring div:nth-child(3) {
        animation-delay: -0.15s;
    }
    @keyframes lds-ring {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    .waiting-room{

        width: 100%;
        height: 100vh;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background-image: linear-gradient(to bottom, #f5f5f5, #ededed, #e5e5e5, #dddddc, #d5d5d4);
        // padding-top: 125px;


        .candidates-container{

            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            width: 95%;
            margin: 0 auto;
            position: relative;

            .candidates{

                .losango{

                    width: 60px;
                    margin-top: 10px;
                }

                .losango0{

                    width: 100px;
                }

                .losango1, .losango2{

                    width: 70px;
                }
            }

            .candidates0{
                order: 3;
                width: 33%;
                margin-top: 30%;
                display: flex;
                flex-direction: column;
                align-items: center;
            }

            .candidates1{

                order : 4;
                width: 33%;
                height: 150px;
                margin-bottom: 55%;
                display: flex;
                justify-content: flex-end;
                align-items: center;
                flex-direction: column;

                .icon-candidate{

                    align-items: center;
                }
            }

            .candidates2{

                order: 2;
                width: 33%;
                height: 150px;
                margin-bottom: 55%;
                display: flex;
                justify-content: flex-end;
                align-items: center;
                flex-direction: column;

                .icon-candidate{

                    align-items: center;
                }
            }

            .candidates3{
                order : 1;
                width: 100%;
                position: absolute;
                top: -25%;
                height: 150px;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                flex-direction: column;
            }
        }   
            

            .acceptance_button{
                display: flex;
                align-items: center;
                text-align: center;
                color: #FFFFFF;
                font-weight: 700;
                text-decoration: none;
                background-color: #000;
                width: 50%;
                transition: background .5s, color .5s, opacity .7s;
                max-width: 300px;
                border-radius: 300px;
                border-bottom: 4px solid #9a9da3;
                height: 50px;
                padding: 0px 70px;
                justify-content: space-around;

                img{
                    width: 25px;
                }


                span{
                    font-size: 15px;
                    letter-spacing: 2px;
                    text-transform: uppercase;
                    // width: 100%
                }

                .arrow-right{
                    width: 0;
                    height: 0;
                    border-top: 6px solid transparent;
                    border-bottom: 6px solid transparent;
                    border-left: 6px solid #000;
                    width: 10%
                }
            }   

            .right{
                left: 50% ;
                border-left: 1px solid black;
            }     

        .waiting-title{

            margin-bottom: 65px;
            font-weight: 900;
            text-transform: uppercase;
            letter-spacing: 0px;
            font-size: 20px;
            color: black;
        }

        .rules-waiting{

            width: 80%;
            margin: 0 auto;
            text-align: center;
            font-size: 12px;
            margin-top: 5%;
        }  

        .notFormed{
            width: 100%;
        }

        .formed{
            width: 50%;
        }
    }

    @media only screen and( min-width: 749px){

        .container-waiting-room{

            height: 100%;

            .waiting-room{
                padding: 0;
                height: calc(100% - 65px);
                justify-content: center;
                position: absolute;

                .waiting-title{

                    margin-top: 0%;
                }

                .candidates-container{

                    width: 45%;
                }

                .rules-waiting{

                    width: 45%;
                    margin: 4%;
                }

                .acceptance_button{
                    // position: absolute;
                    height: 50px;
                }
            }

        }
        
    }
</style>
